<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title"> 제증명신청 </v-col>
    </v-row>

    <div class="overflow-y-auto">
      <v-list>
        <v-list-item-group color="primary">
          <v-list-item v-for="(item, i) in list" :key="i" class="gntType-item">
            <v-list-item-content @click="selectMenu(item)">
              <v-list-item-title>
                <span class="time">{{ item.codeNm }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>

<script>
//import routerNames from '@/const/routerConstants';
import { getReCertAppApplCdList } from '@/api/workStatus';

export default {
  data: () => ({
    list: [],
  }),

  computed: {
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_TITLE_BOTTOM_BTN
      }px;`;
    },
  },

  methods: {
    /* 신청서 선택 */
    async selectMenu(item) {
      if(this.$store.getters.GET_USER_DATA.ssnStatusCd === 'AA'&& item.code === '21')
      {
        alert("재직자는 휴직증명서를 신청할 수 없습니다.");
        return;
      }
      await this.$store.commit('SET_CODE', item.code);
      await this.$store.commit('SET_CODE_NM', item.codeNm);
      await this.$store.commit('SET_APPL_CD', item.applCd);
      await this.$store.dispatch(
        'ELA/FETCH_MENU_ACTION',
          {applCd: item.code}
      ).then((result) => {
        this.$router.push(result);
      });
    },
  },

  async mounted() {
    let params = {};

    let response = await getReCertAppApplCdList(params);
    let tmpList = response.data.data;

    if(this.$store.getters.GET_USER_DATA.ssnStatusCd === 'CA'){
      this.list = tmpList.filter(data => data.code != '11' && data.code != '12' );
    }else{
      this.list = tmpList;
    }
    
    //this.list = response.data.data;

    this.$store.commit('SET_PARAMS', []);
    this.$store.commit('SET_FILE_SEQ', '');
  },
};
</script>

<style></style>
